"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStagedChangesCount = exports.getCustomHostedDomainNameChangesCount = exports.getCalendarIdsToCheckChangesCount = exports.getStagedDefaultLinkChangesCount = exports.getStagedNamespaceChangesCount = exports.getCustomHostedDomainNameOnUser = exports.getCustomHostedDomainOnUser = exports.getCalendarIdToWriteTo = exports.getCalendarEmail = exports.getCalendarIntegrationChoice = exports.getExistingMeetingsLinkSlug = exports.getStagedCalendarUsername = exports.getStagedEwsUri = exports.getStagedCustomHostedDomainName = exports.getStagedCalendarDisplayNames = exports.getStagedCalendarIdsToCheck = exports.getStagedDefaultLinkId = exports.getStagedNamespace = exports.getIsDomainMenuLoading = exports.getIsCalendarMenuLoading = exports.getIsPreferencesMenuLoading = exports.getIsLoading = exports.getMeetingsUserVerified = exports.getValidDomainNames = exports.getValidDomains = exports.getCustomHostedDomains = exports.getCalendarInfo = exports.getEmailProvider = exports.getSettingsConfig = exports.getMeetingsLinks = exports.getMeetingsUser = exports.getUngatedForExchangeConnection = void 0;

var _reselect = require("reselect");

var _get = _interopRequireDefault(require("transmute/get"));

var _selectors = require("settings-ui-sdk/Auth/selectors");

var _requestStatusSelectors = require("./requestStatusSelectors");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _constants = require("settings-ui-sdk/Meetings/constants");

var getUngatedForExchangeConnection = (0, _reselect.createSelector)([_selectors.getUserGates], function (gates) {
  return ['Meetings:Exchange'].every(function (gate) {
    return gates.indexOf(gate) > -1;
  });
});
exports.getUngatedForExchangeConnection = getUngatedForExchangeConnection;

var getMeetings = function getMeetings(state) {
  return state.modules.sales.meetings;
};

var getMeetingsUser = (0, _reselect.createSelector)([getMeetings], function (meetings) {
  return (0, _get.default)('meetingsUser', meetings);
});
exports.getMeetingsUser = getMeetingsUser;
var getMeetingsLinks = (0, _reselect.createSelector)([getMeetings], function (meetings) {
  return (0, _get.default)('meetingsLinks', meetings);
});
exports.getMeetingsLinks = getMeetingsLinks;
var getSettingsConfig = (0, _reselect.createSelector)([getMeetings], function (meetings) {
  return (0, _get.default)('editSettingsConfig', meetings);
});
exports.getSettingsConfig = getSettingsConfig;
var getEmailProvider = (0, _reselect.createSelector)([getMeetings], function (meetings) {
  return (0, _get.default)('emailProvider', meetings);
});
exports.getEmailProvider = getEmailProvider;
var getCalendarInfo = (0, _reselect.createSelector)([getMeetings], function (meetings) {
  return (0, _get.default)('calendarInfo', meetings);
});
exports.getCalendarInfo = getCalendarInfo;
var getCustomHostedDomains = (0, _reselect.createSelector)([getMeetings], function (meetings) {
  return (0, _get.default)('customHostedDomains', meetings);
});
exports.getCustomHostedDomains = getCustomHostedDomains;
var getValidDomains = (0, _reselect.createSelector)([getCustomHostedDomains], function (customHostedDomains) {
  if (!customHostedDomains) {
    return _constants.DEFAULT_VALID_DOMAINS;
  }

  var validFetchedDomains = customHostedDomains.filter(function (customHostedDomain) {
    return customHostedDomain.get('isResolving');
  }).filter(function (customHostedDomain) {
    return !customHostedDomain.get('domain').includes(_constants.HS_SITES);
  });
  return _constants.DEFAULT_VALID_DOMAINS.concat(validFetchedDomains);
});
exports.getValidDomains = getValidDomains;
var getValidDomainNames = (0, _reselect.createSelector)([getValidDomains], function (validDomains) {
  return validDomains.map(function (domain) {
    return domain.get('domain');
  });
});
exports.getValidDomainNames = getValidDomainNames;
var getStagedChanges = (0, _reselect.createSelector)([getSettingsConfig], function (settingsConfig) {
  return settingsConfig.get('stagedChanges');
});
var getMeetingsUserVerified = (0, _reselect.createSelector)([getMeetingsUser, _requestStatusSelectors.getVerifyUserStatus], function (meetingsUser, verifyUserStatus) {
  return Boolean(meetingsUser) && verifyUserStatus === _RequestStatusTypes.default.SUCCEEDED;
});
exports.getMeetingsUserVerified = getMeetingsUserVerified;
var getIsLoading = (0, _reselect.createSelector)([_requestStatusSelectors.getMeetingsUserFetchStatus], function (meetingsUserFetchStatus) {
  var isFetchingUser = meetingsUserFetchStatus === _RequestStatusTypes.default.PENDING || meetingsUserFetchStatus === _RequestStatusTypes.default.UNINITIALIZED;
  return isFetchingUser;
});
exports.getIsLoading = getIsLoading;
var getIsPreferencesMenuLoading = (0, _reselect.createSelector)([_requestStatusSelectors.getLinksFetchStatus, getMeetingsLinks], function (linksFetchStatus, meetingsLinks) {
  var isFetchingLink = linksFetchStatus === _RequestStatusTypes.default.PENDING || linksFetchStatus === _RequestStatusTypes.default.UNINITIALIZED;
  var fetchLinkHasSucceeded = meetingsLinks.find(function (link) {
    return link.isDefaultLink;
  });
  return isFetchingLink && !fetchLinkHasSucceeded;
});
exports.getIsPreferencesMenuLoading = getIsPreferencesMenuLoading;
var getIsCalendarMenuLoading = (0, _reselect.createSelector)([_requestStatusSelectors.getCalendarInfoFetchStatus, _requestStatusSelectors.getVerifyCalendarsStatus, _requestStatusSelectors.getFetchPrimaryCalendarStatus], function (calendarInfoFetchStatus, verifyCalendarsStatus, fetchPrimaryCalendarStatus) {
  var isFetchingCalendarInfo = calendarInfoFetchStatus === _RequestStatusTypes.default.PENDING || calendarInfoFetchStatus === _RequestStatusTypes.default.UNINITIALIZED;
  var isVerifyingCalendarsStatus = verifyCalendarsStatus === _RequestStatusTypes.default.PENDING || verifyCalendarsStatus === _RequestStatusTypes.default.UNINITIALIZED;
  var isFetchingPrimaryCalendar = fetchPrimaryCalendarStatus === _RequestStatusTypes.default.PENDING;
  return isFetchingCalendarInfo || isVerifyingCalendarsStatus || isFetchingPrimaryCalendar;
});
exports.getIsCalendarMenuLoading = getIsCalendarMenuLoading;
var getIsDomainMenuLoading = (0, _reselect.createSelector)([_requestStatusSelectors.getCustomHostedDomainsFetchStatus], function (customHostedDomainsFetchStatus) {
  var isFetchingCustomHostedDomains = customHostedDomainsFetchStatus === _RequestStatusTypes.default.PENDING || customHostedDomainsFetchStatus === _RequestStatusTypes.default.UNINITIALIZED;
  return isFetchingCustomHostedDomains;
});
exports.getIsDomainMenuLoading = getIsDomainMenuLoading;
var getStagedNamespace = (0, _reselect.createSelector)([getStagedChanges], function (stagedChanges) {
  return stagedChanges.get('namespace');
});
exports.getStagedNamespace = getStagedNamespace;
var getStagedDefaultLinkId = (0, _reselect.createSelector)([getStagedChanges], function (stagedChanges) {
  return stagedChanges.get('defaultLinkId');
});
exports.getStagedDefaultLinkId = getStagedDefaultLinkId;
var getStagedCalendarIdsToCheck = (0, _reselect.createSelector)([getStagedChanges], function (stagedChanges) {
  return stagedChanges.get('calendarIdsToCheck');
});
exports.getStagedCalendarIdsToCheck = getStagedCalendarIdsToCheck;
var getStagedCalendarDisplayNames = (0, _reselect.createSelector)([getStagedChanges], function (stagedChanges) {
  return stagedChanges.get('calendarDisplayNames');
});
exports.getStagedCalendarDisplayNames = getStagedCalendarDisplayNames;
var getStagedCustomHostedDomainName = (0, _reselect.createSelector)([getStagedChanges], function (stagedChanges) {
  return stagedChanges.get('customHostedDomainName');
});
exports.getStagedCustomHostedDomainName = getStagedCustomHostedDomainName;
var getStagedEwsUri = (0, _reselect.createSelector)([getStagedChanges], function (stagedChanges) {
  return stagedChanges.get('ewsUri');
});
exports.getStagedEwsUri = getStagedEwsUri;
var getStagedCalendarUsername = (0, _reselect.createSelector)([getStagedChanges], function (stagedChanges) {
  return stagedChanges.get('calendarUsername');
});
exports.getStagedCalendarUsername = getStagedCalendarUsername;
var getExistingMeetingsLinkSlug = (0, _reselect.createSelector)([getMeetingsLinks], function (meetingsLinks) {
  var firstLink = meetingsLinks ? meetingsLinks.first() : null;
  return firstLink ? firstLink.get('slug') : null;
});
exports.getExistingMeetingsLinkSlug = getExistingMeetingsLinkSlug;
var getCalendarIntegrationChoice = (0, _reselect.createSelector)([getMeetingsUser], function (meetingsUser) {
  return meetingsUser.get('calendarIntegrationChoice');
});
exports.getCalendarIntegrationChoice = getCalendarIntegrationChoice;
var getCalendarEmail = (0, _reselect.createSelector)([getMeetingsUser], function (meetingsUser) {
  return meetingsUser.get('calendarEmail');
});
exports.getCalendarEmail = getCalendarEmail;
var getCalendarIdToWriteTo = (0, _reselect.createSelector)([getMeetingsUser], function (meetingsUser) {
  return meetingsUser.get('calendarIdToWriteTo');
});
exports.getCalendarIdToWriteTo = getCalendarIdToWriteTo;
var getCustomHostedDomainOnUser = (0, _reselect.createSelector)([getMeetingsUser], function (meetingsUser) {
  return meetingsUser.get('customHostedDomain');
});
exports.getCustomHostedDomainOnUser = getCustomHostedDomainOnUser;
var getCustomHostedDomainNameOnUser = (0, _reselect.createSelector)([getCustomHostedDomainOnUser], function (customHostedDomain) {
  if (customHostedDomain) {
    return customHostedDomain.get('domain');
  }

  return null;
});
exports.getCustomHostedDomainNameOnUser = getCustomHostedDomainNameOnUser;
var getStagedNamespaceChangesCount = (0, _reselect.createSelector)([getMeetingsUser, getStagedNamespace], function (meetingsUser, stagedNamespace) {
  return meetingsUser.get('namespace') !== stagedNamespace ? 1 : 0;
});
exports.getStagedNamespaceChangesCount = getStagedNamespaceChangesCount;
var getStagedDefaultLinkChangesCount = (0, _reselect.createSelector)([getSettingsConfig, getStagedChanges], function (settingsConfig, stagedChanges) {
  return settingsConfig.defaultLinkId !== stagedChanges.defaultLinkId ? 1 : 0;
});
exports.getStagedDefaultLinkChangesCount = getStagedDefaultLinkChangesCount;
var getCalendarIdsToCheckChangesCount = (0, _reselect.createSelector)([getMeetingsUser, getStagedChanges], function (meetingsUser, stagedChanges) {
  return meetingsUser.get('calendarIdsToCheck').equals(stagedChanges.get('calendarIdsToCheck')) ? 0 : 1;
});
exports.getCalendarIdsToCheckChangesCount = getCalendarIdsToCheckChangesCount;
var getCustomHostedDomainNameChangesCount = (0, _reselect.createSelector)([getCustomHostedDomainNameOnUser, getStagedChanges], function (customHostedDomainNameOnUser, stagedChanges) {
  return customHostedDomainNameOnUser === stagedChanges.get('customHostedDomainName') ? 0 : 1;
});
exports.getCustomHostedDomainNameChangesCount = getCustomHostedDomainNameChangesCount;
var getStagedChangesCount = (0, _reselect.createSelector)([getStagedNamespaceChangesCount, getStagedDefaultLinkChangesCount, getCalendarIdsToCheckChangesCount, getCustomHostedDomainNameChangesCount], function (stagedNamespaceChangesCount, stagedDefaultLinkChangesCount, calendarIdsToCheckChangesCount, customHostedDomainNameChangesCount) {
  return stagedNamespaceChangesCount + stagedDefaultLinkChangesCount + calendarIdsToCheckChangesCount + customHostedDomainNameChangesCount;
});
exports.getStagedChangesCount = getStagedChangesCount;